import '@/legacy/legacy.js';
import '@/libraries/inlarge.js';
import Header from '@/modules/Header.js';
import ImageCover from '@/modules/ImageCover.js';
import NavMain from '@/modules/NavMain.js';
import Slider from './modules/Slider';
import NavMobile from './modules/NavMobile';
import Accordion from './modules/Accordion';
import MobileLogin from './modules/MobileLogin';
import VideoModal from './modules/VideoModal';
import LoadMore from './modules/LoadMore';
import Reveal from './modules/Reveal';

document.addEventListener('DOMContentLoaded', function() {
    NavMain.init({
        selector: '[data-js="site-nav"]',
    });

    NavMobile.init({
        selector: '[data-js="site-nav"]',
    });

    Header.init({
        selector: '[data-js="site-header"]',
    });

    Slider.init({
        selector: '[data-js="slideshow-recent-posts"]',
    });

    Slider.init({
        selector: '[data-js="slideshow-featured-cards"]',
    });

    ImageCover.init({
        selector: '[data-js="image-cover"]',
    });

    VideoModal.init({
        selector: '[data-js="video-player"]',
    });

    LoadMore.init({
        selector: '[data-js="load-more"]',
    });

    Reveal.init({
        selector: '[data-js="reveal"]',
    });

    const $menuAccordions = $(
        '[data-js="menu-accordion"] .menu-item-has-children'
    );

    $.each($menuAccordions, (index, elem) => {
        Accordion.init({
            selector: elem,
        });
    });
});

window.addEventListener('load', function() {
    MobileLogin.init({
        selector: '[data-js="mobile-login"]',
    });
});
